<template>
  <!-- <el-dialog :visible.sync="showModal" width="80%"> -->
  <el-card>
    <div class="modal_title">
      <el-row type="flex" align="middle">
        <el-row type="flex" align="middle">
          <el-button type="primary" size="small" @click="$myRouter.go(-1)">返 回</el-button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;试卷名称&nbsp;:&nbsp;&nbsp;
        </el-row>
        <p class="modal_title_text">{{title}}</p>
      </el-row>
    </div>
    <br>
    <el-form :model="searchForm" inline label-width="100px" size="small" ref="form">
      <el-form-item label="题目" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入关键字" />
      </el-form-item>
      <el-form-item label="题型" prop="type">
        <el-select v-model="searchForm.type" placeholder="请选择">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in subjectType" :key="index" />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left: 50px">
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset('form')" style="margin-left: 8px">重置</el-button>
      </el-form-item>
      <el-form-item style="margin-left: 50px">
        <el-button type="primary" @click="export_action('daochu')">导出题目</el-button>
        <!-- <el-button style="margin-left: 8px" @click="export_action('daoru')">导入题目</el-button> -->
        <el-button style="margin-left: 8px" @click="export_action('down')">下载模板</el-button>
        <el-upload class="upload-demo" accept=".xlsx" :action="uploadbaseURL" :on-success="uploadSuccess" :before-upload="uploadBefore" :on-error="uploadError" :headers="uploadHeader">
          <el-button size="small" type="primary" :loading="exportLocalLoading">导入题目</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-row align="middle">
      <el-col :span="24">
        <el-button type="primary" @click="action('add')" size="small">添加题目</el-button>
        <el-button type="primary" @click="action('select')" size="small">选择题目</el-button>
        <el-alert :closable="false" class="score" type="info">当前试卷总分: {{totalScore}}</el-alert>
      </el-col>
    </el-row>
    <br />
    <subjectTable ref="subjectTable" :tableData="tableData" :loading="loading" @update="update" :examPaperId="examPaperId" />
    <br />
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <div slot="footer">
      <!-- <el-button @click="showModal = false">取 消</el-button> -->
      <!-- <el-button type="primary" @click="showModal = false">关 闭</el-button> -->
    </div>
    <!-- 添加题目 -->
    <subjectAdd ref="subjectAdd" :examPaperId="examPaperId" @update="update" />
    <!-- 选择题目 -->
    <subjectList ref="subjectList" @update="update" />
    <!-- </el-dialog> -->
  </el-card>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"
import { subjectType } from "../../dict"
import { projectMoudel } from "../../mixins"
import { examPaperTopicPage, examPaperTopicDels, examPaperGet } from "../../api"

import subjectAdd from "../../subjectAdmin/com/add.vue"
import subjectTable from "../../subjectAdmin/com/table.vue"
import subjectList from "../../subjectAdmin/com/subjectList.vue"
import { downloadData } from '@/api/common'
import Cookies from 'js-cookie'

import excel from '@/libs/excel'
import { baseURL } from '@/api/request'

export default {
  components: { subjectAdd, subjectTable, subjectList },
  mixins: [tableMoudel, projectMoudel],
  data () {
    return {
      uploadbaseURL: `${baseURL}/exam/adm/examPaperTopic/importExamPaperTopic`,
      uploadHeader: {},
      subjectType,
      showModal: false,
      title: '暂无题目',
      searchForm: {
        title: null,
        type: null
      },
      totalScore: 0,//试卷总分
      examPaperId: null,//题目id
      exportLocalLoading: false,
      tableLocalData: []
    }
  },
  created () {
    this.init()
    const token = Cookies.get('tvToken') || Cookies.get('token')
    if (token) {
      this.uploadHeader = {
        Authorization: 'Bearer ' + token
      }
    }
  },
  methods: {
    exportLocalExcel () {
      if (this.tableLocalData.length > 0) {
        const params = {
          title: ['试卷名称', '题目', '题型', '选项A', '选项B', '选项c', '选项D', '选项E', '材料', '答案', '解析', '分值', '排序号', '备注'],
          key: ['titleExamPaper', 'titleExamTopic', 'type', 'examOptionA', 'examOptionB', 'examOptionC', 'examOptionD', 'examOptionE', 'material', 'answer', 'parsing', 'score', 'sortNum', 'remarks'],
          data: this.tableLocalData,
          autoWidth: true,
          filename: '导入报告' + Date.parse(new Date())
        }
        excel.export_array_to_excel(params)
        this.$message.info('导入结束，请查看导入报告！')
      } else {
        this.$message.info('导入报告为空！')
      }
    },
    uploadSuccess (response, file, fileList) {
      this.tableLocalData = response.data
      this.exportLocalExcel()
      this.exportLocalLoading = false
      this.getData('init')
    },
    uploadBefore (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx') {
        if (this.exportLocalLoading == false) {
          this.exportLocalLoading = true
          return true
        } else {
          this.$message.error('正在导入中请不要进行操作！')
        }
      } else {
        this.$message.error('文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx的EXCEL文件。')
      }
      return false
    },
    uploadError (error, file, fileList) {
      this.$message.error('网络异常，请联系管理员。')
      this.exportLocalLoading = false
    },
    // init (id, title = '暂无题目', totalScore, projectId) {
    init (title = '暂无题目') {
      const id = this.$route.query.id
      const projectId = this.$route.query.projectId
      // this.totalScore = totalScore
      // this.title = `${title}`
      this.examPaperId = id
      this.projectId = projectId
      this.examPaperGet()
      this.getData()
      this.showModal = true
    },
    async examPaperGet () {
      const res = await examPaperGet({ id: this.examPaperId })
      const { data } = res
      this.totalScore = data.totalScore
      this.title = data.title
    },
    //关联试卷
    relationPaper () {
      const projectId = this.projectId
      this.$refs.testPaperList.init(this.examPaperId, projectId)
    },
    update () {
      this.getData()
    },
    async getData () {
      const params = {
        ...this.pageInfo,
        ...this.searchForm,
        examPaperId: this.examPaperId
      }
      const res = await examPaperTopicPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records.map(item => {
        item.sortShow = false
        item.sortNumShow = false
        item.insertDate = item.examTopic.insertDate
        item.sortNum = item.sortNum || ''
        return {
          ...item.examPaper,
          ...item.examTopic,
          ...item,
        }
      })
    },
    action (key) {
      switch (key) {
        case 'add':
          this.$refs.subjectAdd.init()
          break;
        case 'select':
          this.$refs.subjectList.init(this.examPaperId, this.projectId)
          break;
        case 'del':
          this.$confirm('确定删除关联?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await examPaperTopicDels({ id: item.id })
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('删除成功!')
            this.reset()
          })
          break;

      }
    },
    async export_action (key) {
      switch (key) {
        case 'daochu':
          console.log('导出')
          downloadData(
            `/exam/adm/examPaperTopic/exportExamPaperTopic`,
            {examPaperId: this.examPaperId}
          )
          break;
        case 'down':
          console.log('下载模板')
          downloadData(
            `/exam/adm/examPaperTopic/exportExamPaperTopic`,
            {examPaperId: 0}
          )
          break;
        case 'daoru':
          console.log('导入')
          break;

        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal_title {
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 15px;
  white-space: nowrap;
}

::v-deep .el-dialog__body {
  padding: 15px 20px 20px;
}
.score {
  margin: 0 12px;
  display: inline-block;
  vertical-align: middle;
  ::v-deep .el-alert__description {
    font-weight: bold;
    font-size: 14px;
  }
}
::v-deep .el-alert.score {
  width: 50%;
}

.upload-demo {
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
}
::v-deep .el-upload-list {
  display: inline-block;
  vertical-align: middle;
  margin: 0 12px;
  .el-upload-list__item:first-child {
    margin: 0;
  }
}
</style>
